import { handleResponse } from "core/api/apiHelpers";
import type { Middleware, ResponseContext } from "core/api/coreApiClient";

class ResponseHandlerMiddleware implements Middleware {
  post = async (context: ResponseContext) => {
    return handleResponse(context.url, context.response);
  };
}

export default ResponseHandlerMiddleware;
